import type { CaseCatalog, CatalogCase } from './catalog.types';

export const SIMILAR_CASES_COUNT = 4;

export interface SimilarCasesTarget {
  id: string;
  priceInCredits: number;
  openCurrency?: string;
}

// WHY: цены кейсов идут от сотен до миллионов — близость считаем по отношению цен: разница в 500 у кейса за 500 — это
// вдвое дороже, а у кейса за миллион — та же цена
const priceDistance = (a: number, b: number): number => Math.abs(Math.log(Math.max(a, 1) / Math.max(b, 1)));

const compareRanks = (a: number[], b: number[]): number => {
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return a[i] - b[i];
  }
  return 0;
};

// WHY: без localeCompare — порядок на сервере и в браузере обязан совпасть, а сравнение строк по локали зависит от ICU
const compareIds = (a: string, b: string): number => (a < b ? -1 : a > b ? 1 : 0);

export function similarCases(catalog: CaseCatalog, target: SimilarCasesTarget, count = SIMILAR_CASES_COUNT): CatalogCase[] {
  const categoryMates = new Set(
    catalog.categories.filter((category) => category.cases.some((c) => c.id === target.id)).flatMap((category) => category.cases.map((c) => c.id)),
  );
  const candidates = new Map<string, CatalogCase>();
  for (const c of catalog.general) {
    if (c.id !== target.id && !candidates.has(c.id)) candidates.set(c.id, c);
  }
  const rank = (c: CatalogCase): number[] => [
    c.openCurrency === target.openCurrency ? 0 : 1,
    priceDistance(c.priceInCredits, target.priceInCredits),
    categoryMates.has(c.id) ? 0 : 1,
    -c.openingsCount,
  ];
  return [...candidates.values()]
    .map((c) => ({ c, rank: rank(c) }))
    .sort((a, b) => compareRanks(a.rank, b.rank) || compareIds(a.c.id, b.c.id))
    .slice(0, count)
    .map(({ c }) => c);
}
